var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUnionPay = function SvgUnionPay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 20,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#unionPay_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 20,
    fill: "#fff",
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EC0415",
    d: "M7.3 10.005c0-3.068 2.522-5.547 5.645-5.542 3.107.005 5.617 2.47 5.63 5.51.014 3.099-2.548 5.57-5.658 5.562-3.096-.007-5.618-2.485-5.617-5.53"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#029AE0",
    d: "M13.425 10.005c0-3.068 2.522-5.547 5.645-5.542 3.107.005 5.617 2.47 5.63 5.51.014 3.099-2.548 5.57-5.658 5.562-3.096-.007-5.618-2.485-5.617-5.53"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C6BBE",
    d: "M15.997 5.35c1.546.982 2.57 2.685 2.578 4.623.009 1.97-1.025 3.685-2.578 4.672-1.547-.986-2.574-2.697-2.574-4.64 0-1.954 1.024-3.67 2.574-4.656"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "unionPay_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v20H0z"
  })))));
};
export default SvgUnionPay;